import { useState } from "react";
import { T } from "./partner/PartnerTranslations";
import { CarolChatMockup } from "./partner/PartnerMockups";
import { DifferentialsSection } from "./partner/PartnerDifferentials";
import { HowToSellSection, ArgumentsSection } from "./partner/PartnerSections";
import { CommissionSection, CTASupportSection } from "./partner/PartnerCommission";

const PANEL = "https://kaisosystem.com/affiliate";
const LANGS = [{ k: "pt", l: "PT" }, { k: "es", l: "ES" }, { k: "en", l: "EN" }];

function LangSwitcher({ lang, setLang }) {
  return (
    <div style={{ display: "flex", gap: 4 }}>
      {LANGS.map(({ k, l }) => (
        <button key={k} onClick={() => setLang(k)} style={{
          background: lang === k ? "#22c55e" : "transparent",
          color: lang === k ? "#000" : "#888",
          border: `1px solid ${lang === k ? "#22c55e" : "#333"}`,
          borderRadius: 6, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer",
        }}>
          {l}
        </button>
      ))}
    </div>
  );
}

function Header({ lang, setLang, t }) {
  return (
    <div style={{
      background: "#111", borderBottom: "1px solid #1e1e1e", padding: "14px 24px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      flexWrap: "wrap", gap: 10, position: "sticky", top: 0, zIndex: 100,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg,#22c55e,#16a34a)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>⚡</div>
        <span style={{ fontWeight: 800, fontSize: 15, color: "#fff" }}>Kaiso System</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <LangSwitcher lang={lang} setLang={setLang} />
        <a href={PANEL} style={{ background: "#22c55e", color: "#000", padding: "8px 16px", borderRadius: 8, fontWeight: 700, fontSize: 13, textDecoration: "none", whiteSpace: "nowrap" }}>
          {t.panel_btn}
        </a>
      </div>
    </div>
  );
}

function Hero({ t }) {
  return (
    <div style={{ padding: "56px 0 48px" }}>
      <div style={{ display: "inline-block", background: "#1a2e1a", border: "1px solid #22c55e44", borderRadius: 20, padding: "6px 16px", fontSize: 13, color: "#4ade80", marginBottom: 22, fontWeight: 700 }}>
        {t.badge}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 40, alignItems: "center" }}>
        <div>
          <h1 style={{ fontSize: "clamp(26px,4.5vw,42px)", fontWeight: 900, lineHeight: 1.15, margin: "0 0 20px", color: "#fff" }}>
            {t.hero_title[0]}{" "}
            <span style={{ color: "#22c55e" }}>{t.hero_title[1]}</span>{" "}
            {t.hero_title[2]}
          </h1>
          <p style={{ fontSize: 15, color: "#999", margin: "0 0 32px", lineHeight: 1.7 }}>
            {t.hero_sub}
          </p>

          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 32 }}>
            <a href={PANEL} style={{ display: "inline-block", background: "linear-gradient(135deg,#22c55e,#16a34a)", color: "#000", padding: "13px 28px", borderRadius: 10, fontWeight: 800, fontSize: 15, textDecoration: "none", boxShadow: "0 4px 20px #22c55e44" }}>
              {t.hero_cta}
            </a>
            <a href="#diferenciais" style={{ display: "inline-block", background: "transparent", color: "#ccc", padding: "13px 28px", borderRadius: 10, fontWeight: 700, fontSize: 15, textDecoration: "none", border: "1px solid #333" }}>
              {t.hero_cta2}
            </a>
          </div>

          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {t.hero_stats.map((s) => (
              <div key={s} style={{ background: "#1a2e1a", border: "1px solid #22c55e33", borderRadius: 20, padding: "5px 14px", fontSize: 12, color: "#4ade80", fontWeight: 700 }}>
                {s}
              </div>
            ))}
          </div>
        </div>

        <div>
          <CarolChatMockup t={t} />
        </div>
      </div>
    </div>
  );
}

export default function PartnerStartPage() {
  const [lang, setLang] = useState("es");
  const t = T[lang];
  return (
    <div style={{ background: "#0a0a0a", minHeight: "100vh", fontFamily: "'Inter',sans-serif", color: "#f5f5f5" }}>
      <Header lang={lang} setLang={setLang} t={t} />
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "0 20px 60px" }}>
        <Hero t={t} />
        <div id="diferenciais"><DifferentialsSection t={t} /></div>
        <HowToSellSection t={t} />
        <ArgumentsSection t={t} />
        <CommissionSection t={t} />
        <CTASupportSection t={t} />
        <div style={{ textAlign: "center", paddingTop: 20, color: "#333", fontSize: 12 }}>
          © {new Date().getFullYear()} Kaiso System · {t.footer}
        </div>
      </div>
    </div>
  );
}
